/**
 * Human labels for a contact's stepHistory entry on the live sequence.
 */

export function describeStepHistory(stepType, hist) {
  if (!hist || typeof hist !== "object") return "";
  const reason = typeof hist.reason === "string" ? hist.reason : "";
  const found = typeof hist.found === "number" ? hist.found : null;

  if (stepType === "web_research") {
    const mods = Array.isArray(hist.modules) ? hist.modules : [];
    if (mods.length > 0 && !mods.includes("decisionMakers")) {
      return "Ran without Decision Makers (not in this step’s modes)";
    }
    if (found === 0) return "No decision makers found";
    if (found === 1) return "1 decision maker";
    if (found > 1) return `${found} decision makers`;
  }

  if (stepType === "dm_email_finder") {
    if (reason === "no_decision_makers") return "No decision makers — search skipped";
    if (reason === "no_email_found") return "People found, no usable email";
    if (found != null) return found === 1 ? "1 email found" : `${found} emails found`;
    if (hist.result === "dm_email_finder_done") return "Emails found";
    if (hist.result === "dm_email_finder_skipped") return "Search skipped";
  }

  if (reason) return reason.replace(/_/g, " ");
  if (typeof hist.result === "string" && hist.result) return hist.result.replace(/_/g, " ");
  return "";
}

export function stepHistoryEmails(hist) {
  if (!hist || !Array.isArray(hist.emails)) return [];
  return hist.emails.map((e) => String(e || "").trim()).filter(Boolean).slice(0, 6);
}

export function compactStepHistory(result) {
  if (!result || typeof result !== "object") return {};
  const extra = {};
  if (result.reason) extra.reason = String(result.reason).slice(0, 80);
  if (typeof result.found === "number") extra.found = result.found;
  if (typeof result.searched === "number") extra.searched = result.searched;
  if (Array.isArray(result.emails)) {
    extra.emails = result.emails.map((e) => String(e || "").trim()).filter(Boolean).slice(0, 6);
  }
  if (Array.isArray(result.modules)) {
    extra.modules = result.modules.map((m) => String(m || "").trim()).filter(Boolean).slice(0, 16);
  }
  return extra;
}
